(() => {
  const initKorsanMotion = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const sections = Array.from(document.querySelectorAll('main > .shopify-section'));
    const revealTargets = [];

    sections.forEach((section, index) => {
      if (index === 0) return;

      const content = section.querySelector(':scope > *');
      if (!content) return;

      content.setAttribute('data-korsan-reveal', '');
      revealTargets.push(content);
    });

    const grids = document.querySelectorAll(
      '.product-grid, .collection-list, .resource-list, .section-resource-list__content, .section-carousel'
    );

    grids.forEach((grid) => {
      const cards = grid.querySelectorAll(':scope > *, :scope product-card, :scope collection-card');
      if (cards.length < 2) return;

      grid.setAttribute('data-korsan-stagger', '');
      cards.forEach((card) => {
        if (!card.hasAttribute('data-korsan-reveal')) {
          card.setAttribute('data-korsan-reveal', '');
          revealTargets.push(card);
        }
      });
    });

    if (!('IntersectionObserver' in window)) {
      revealTargets.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, motionObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          motionObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -8% 0px',
      }
    );

    revealTargets.forEach((element) => observer.observe(element));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKorsanMotion, { once: true });
  } else {
    initKorsanMotion();
  }

  document.addEventListener('shopify:section:load', initKorsanMotion);
})();
